import { FormDrawer, FormDrawerContent, isSuccess, useToasts } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { addMonths, format } from "date-fns";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { applicationService } from "../shared/api/applicationService";
import { MailcoachApplicationFormValues } from "../shared/types/application";
import { BaseApplicationDataFields } from "./BaseApplicationDataFields";
import { useBaseApplicationFormValidate } from "./baseApplicationFormValidate";

interface Props {
	open: boolean;
	onClose: () => void;
}

const initialValues: MailcoachApplicationFormValues = {
	setupDate: format(Date.now(), "yyyy-MM-dd"),
	deletionDate: format(addMonths(new Date(), 12), "yyyy-MM-dd"),
	subdomain: "",
	projectNumber: "",
};

export const CreateMailcoachApplicationDrawer: FC<Props> = ({ ...props }) => {
	const { t } = useTranslation();
	const { showToast } = useToasts();
	const queryClient = useQueryClient();
	const validate = useBaseApplicationFormValidate();

	const handleSubmit = async (values: MailcoachApplicationFormValues) => {
		const response = await applicationService.storeMailcoach(values);

		if (isSuccess(response)) {
			void queryClient.invalidateQueries({ queryKey: applicationService.keys.list });
			showToast({
				type: "success",
				title: t("Create newsletter"),
				body: t("Application was successfully created."),
			});
			return true;
		}

		return false;
	};

	return (
		<FormDrawer
			{...props}
			title={t("Create newsletter")}
			validate={validate}
			onSubmit={handleSubmit}
			initialValues={initialValues}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<BaseApplicationDataFields />
				</FormDrawerContent>
			)}
		/>
	);
};
